export const environment = {
    production: false,
    firebaseConfig: {
        apiKey: "AIzaSyAjxRF8i4gvYEpVR8Uc88cXbcDqt6W8fgY",
        authDomain: "epseportal.firebaseapp.com",
        databaseURL: "https://epseportal.firebaseio.com",
        projectId: "epseportal",
        storageBucket: "epseportal.appspot.com",
        messagingSenderId: "947716330263"
    },
    delay: 1000,
    apiUrl: ''
};



// WEBPACK FOOTER //
// C:/Users/cmcever/Documents/GitHub/ChallengerTurf/EPSePortal/src/environments/environment.ts